import React from "react"
import "./TooltipTable.scss"

type TooltipTableProps = {
	children?: React.ReactNode
	className?: string
}

const TooltipTable = (props: TooltipTableProps) => {
	const { children, className } = props

	return <div className={`tooltip-table ${className}`}>{children}</div>
}

export default TooltipTable
